import React from 'react';
import './Footer.css';
import logo from '../assets/presson.png'; // tu logo PressOn en PNG
import { FaTwitter, FaFacebookF, FaInstagram } from 'react-icons/fa';

export default function Footer() {
  return (
    <footer className="footer">
      <div className="footer-container">

        {/* Logo + líneas */}
        <div className="footer-logo">
          <hr className="line top" />
          <img src={logo} alt="PressOn Logo" />
          <hr className="line bottom" />
        </div>

        {/* Contactos */}
        <div className="footer-section">
          <h4>CONTACTOS</h4>
          <p>56-5335-0901</p>
          <p>alex.perea1212@gmail.com</p>
          <div className="social-icons">
            <a href="https://twitter.com" target="_blank" rel="noopener noreferrer">
              <FaTwitter />
            </a>
            <a href="https://facebook.com" target="_blank" rel="noopener noreferrer">
              <FaFacebookF />
            </a>
            <a href="https://instagram.com" target="_blank" rel="noopener noreferrer">
              <FaInstagram />
            </a>
          </div>
        </div>

        {/* Dirección */}
        <div className="footer-section">
          <h4>DIRECCIÓN</h4>
          <p>12 Francisco I Madero,</p>
          <p>Xonacatlán, Estado de México, 52060</p>
        </div>

      </div>
    </footer>
  );
}
